







import { Component, Vue } from 'vue-property-decorator';
import Auth from '@/layouts/Auth.vue';

@Component({
  name: 'forgot-password',
  components: {
    Auth,
  },
})

export default class ForgotPasswordPage extends Vue {}
